export const LinksKeys = {
    TermsAndCondition: 'https://help.ableapp.com/en/articles/5590061-eula',
    PrivacyPolicy: 'https://help.ableapp.com/en/articles/5590060-privacy-notice'
};
